import { useState, useEffect, useRef } from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Hosts from '../../../Hosts';
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { Modal, Button, Form } from 'react-bootstrap';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	pattern_vat,
	pattern_email,
	passwordHash,
	translate,
	handle_compressed_image_upload,
	set_language
} from '../../../Utils';

import { language } from './Language';
import { color } from '../../WEBContent/Color';
import { set } from 'core-js/core/dict';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const [, setForceUpdate] = useState(false);
	const permissions = useRef(null);
	const { pathname } = useLocation();

	//Entity Profiles
	const entity_category = useRef(null);

	const entity_type = useRef(null);
	const entity_type_filter = useRef(null);

	const entity_nature = useRef(null);
	const entity_nature_filter = useRef(null);

	const entity_quality = useRef(null);
	const entity_quality_filter = useRef(null);

	const entity_legal_form = useRef(null);
	const entity_legal_form_filter = useRef(null);

	const entity_relation = useRef(null);
	const entity_relation_raw = useRef(null);
	const entity_relation_filter = useRef(null);

	const app_profiles = useRef(null);
	const app_profiles_filter = useRef(null);

	const entity_profiles = useRef(null);
	const entity_profiles_filter = useRef(null);

	const entity_dimension = useRef(null);
	const entity_dimension_filter = useRef(null);

	const entity_sector = useRef(null);
	const entity_sector_filter = useRef(null);

	const entity_list = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [lang_id, set_lang_id] = useState('1');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');
	const [/*disabled*/, set_disabled] = useState(false)

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	/////////////////////////////////////////////////////////////////////////
	const [selectedUserTypeId, setSelectedUserTypeId] = useState('');
	const [userTypes, setUserTypes] = useState([]);
	const [userTypesEntities, setUserTypesEntities] = useState([]);
	const [modalDetalhes, setModalDetalhes] = useState(false);

	//Responsaveis///////////////////////////////////////////////////////////
	const [modalResponsavel, setModalResponsavel] = useState(false);
	const [responsavelInputNome, setResponsavelInputNome] = useState('');
	const [responsavelInputEmail, setResponsavelInputEmail] = useState('');
	const [responsavelInputTel, setResponsavelInputTel] = useState('');
	const [allResponsaveis, setAllResponsaveis] = useState([]);
	const [teamLeader, setTeamLeader] = useState([]);

	//Departamento
	const [modalDepartamento, setModalDepartamento] = useState(false);
	const [departamentos, setDepartamentos] = useState([]);
	const [selectedDepartamentoId, setSelectedDepartamentoId] = useState('');
	const [departamentoSelecionado, setDepartamentoSelecionado] = useState([]);
	const [departamentoInput, setDepartamentoInput] = useState('');
	const [selectedDepartamento, setSelectedDepartamento] = useState(null);
	const [selectedSoftware, setSelectedSoftware] = useState({});

	//Entidade Interna
	const [colaborador, setColaborador] = useState('');
	const [selectedColaborador, setSelectedColaborador] = useState('');

	//Entidade Externa
	const [tipoCliente, setTipoCliente] = useState('');
	const [selectedTipoCliente, setSelectedTipoCliente] = useState('');

	//Relacao	
	const [selectedTipoRelacao, setSelectedTipoRelacao] = useState('');

	//Logo	
	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [logo_base64, set_logo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])

	//pdf
	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	const [treeDataCV, setTreeDataCV] = useState([])

	//////////////////////////////////////////////////////////////////////////
	const [showInter, setShowInter] = useState(false);
	const [showNat, setShowNat] = useState(false);
	const [showOverView, setShowOverview] = useState(false);
	const [showFunctions, setShowFunctions] = useState(true);
	const [showFiscalData, setShowFiscalData] = useState(false);
	const [showContract, setShowContract] = useState(false);
	const [showSettings, setShowSettings] = useState(false);
	//////////////////////////////////////////////////////////////////////////
	const [coletivaOrIndividual, setColetivaOrIndividual] = useState(null); // true for collective, false for individual
	//////////////////////////////////////////////////////////////////////////

	console.log('##### AKI0', JSON.parse(JSON.stringify(dados.current)))

	const entidadeOptions = [
		{ id: "1", label: "Interna" },
		{ id: "2", label: "Externa" },
	];

	const tipoEntidadeOptions = [
		{ id: "1", label: "Pessoal" },
		{ id: "2", label: "Empresarial" },
	];

	const tipoRelacaoOptions = [
		{ id: "1", label: "Agente" },
		{ id: "2", label: "Cliente" },
		{ id: "3", label: "Colaborador" },
		{ id: "4", label: "Distribuidor" },
		{ id: "5", label: "Fornecedor" },
		{ id: "6", label: "Investidor" },
		{ id: "7", label: "Parceiro" },
		{ id: "8", label: "Sócio" },
		{ id: "9", label: "Outro" },
	];

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

	const tableStyle = {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: '14px',
		color: color.cor1.hexa,
		textAlign: 'left',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: color.cor3.hexa,
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.cor2.rgb,
		textTransform: 'uppercase',
	};

	const departamentoHeaderCellStyle = {
		...headerCellStyle,
		textAlign: 'left',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: color.cor3.hexa,
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
	};

	const actionCellStyle = {
		padding: '10px',
		border: '1px solid #ddd',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: '50px',
		backgroundColor: color.cor1.hexa,
		transition: 'background-color 0.3s',
	};

	const departmentCellStyle = {
		backgroundColor: color.cor1.hexa,
		...cellStyle,
		textAlign: 'left',
		fontWeight: '500',
	};

	const lastRowStyle = {
		borderBottom: '0.5px solid grey',
	};

	const handleEntidade = (event) => {
		const value = event.target.value;
		const selectedOption = entidadeOptions.find((option) => option.id === value);

		if (!Array.isArray(dados.current.info.entity)) {
			dados.current.info.entity = [];
		}

		dados.current.info.entity = [{ id: selectedOption.id, label: selectedOption.label }];

		setColaborador(selectedOption.label);
		setSelectedColaborador(selectedOption.id);
	};

	const handleTipoEntidade = (event) => {
		const value = event.target.value;
		const selectedOption = tipoEntidadeOptions.find((option) => option.id === value);

		if (!Array.isArray(dados.current.info.type)) {
			dados.current.info.type = [];
		}

		dados.current.info.type = [{ id: selectedOption.id, label: selectedOption.label }];
		dados.current.info.profile = { name: selectedOption.label };

		setTipoCliente(selectedOption.label);
		setSelectedTipoCliente(selectedOption.id);
	};

	const handleRelacaoChange = (event) => {
		const { value, checked } = event.target;

		if (!dados.current.info.relacao) {
			dados.current.info.relacao = [];
		}

		const selectedOption = tipoRelacaoOptions.find(option => option.id === value);

		if (checked && selectedOption) {
			if (!dados.current.info.relacao.some(item => item.id === value)) {
				dados.current.info.relacao.push({ id: selectedOption.id, label: selectedOption.label });
			}
			setSelectedTipoRelacao(prev => [...prev, selectedOption.label]);
		} else {
			dados.current.info.relacao = dados.current.info.relacao.filter(item => item.id !== value);
			setSelectedTipoRelacao(prev => prev.filter(label => label !== selectedOption.label));
		}
	};

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)
		window.location.reload()

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	const handleUserTypeChange = (e) => {
		const selectedValue = e.target.value;
		setSelectedUserTypeId(selectedValue);
		set_dados(dados.current.profile.name = selectedValue);
	};

	const handleUserTypeEntityChange = (e) => {
		const selectedValue = e.target.value;
		let id_aux = userTypesEntities.filter(el => el.name === selectedValue)

		let aux = {
			id: id_aux[0].id,
			name: selectedValue
		}

		if (!Array.isArray(dados.current.info.entity_profile)) {
			dados.current.info.entity_profile = []
		}
		let aux_2 = dados.current.info.entity_profile.filter(el => parseInt(el.id) !== parseInt(aux.id))
		aux_2.push(aux)

		set_dados(dados.current.info.entity_profile = aux_2);

		console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
		console.log('Dados Current:', (dados.current.info))
		// console.log('Dados Current:' + JSON.stringify(dados.current.info))

	};

	const handleUserTypeEntityRemove = (id) => {

		Swal.fire({
			title: language[lang].remove_title,
			text: language[lang].remove_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].remove_confirm,
			cancelButtonText: language[lang].remove_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let aux = dados.current.info.entity_profile.filter(el => parseInt(el.id) !== parseInt(id))
					set_dados(dados.current.info.entity_profile = aux);

				}
			})

	}

	/// DEPARTAMENTOS ///////////////////////////////////////////////////

	const handleCloseModal = () => {
		// Simply close the modal by setting modalDetalhes to false
		setModalDetalhes(false);

		// Optionally, reset selectedDepartamento if you don't want to keep the previous data
		setDepartamentoSelecionado(null);
	};

	const handleSaveChanges = () => {
		if (!selectedDepartamento) {
			console.error("No department selected to update.");
			return;
		}

		const updatedDepartamentos = [...dados.current.contacts[0].departamentos];
		const departamentoIndex = updatedDepartamentos.findIndex(dep => dep.id === selectedDepartamento.id);

		if (departamentoIndex !== -1) {
			updatedDepartamentos[departamentoIndex] = { ...selectedDepartamento };

			dados.current.contacts[0].departamentos = updatedDepartamentos;

			set_dados(prevDados => {
				if (!prevDados?.contacts?.length) {
					return prevDados;
				}

				const updatedContacts = [...prevDados.contacts];

				updatedContacts[0] = {
					...updatedContacts[0],
					departamentos: updatedDepartamentos
				};

				return {
					...prevDados,
					contacts: updatedContacts
				};
			});

		} else {
			console.error("Department not found for update:", selectedDepartamento);
		}
		setModalDetalhes(false);
	};

	const handleAddDepartamento = () => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Calculate new ID for departamento
		const departamentos = dados.current.contacts[0].departamentos;
		const departamentoExists = departamentos.some(dep => dep.name.toLowerCase() === departamentoInput.toLowerCase());

		if (departamentoExists) {
			alert("O departamento já existe.");
			return;
		}

		const newId = departamentos.length > 0 ? departamentos[departamentos.length - 1].id + 1 : 1;

		// Create the new departamento object
		const newDepartamento = { id: newId, name: departamentoInput, responsaveis: [] };

		// Push the new departamento to both dados.current and data_interface
		dados.current.contacts[0].departamentos.push(newDepartamento);

		// Clear the input and close the modal
		setDepartamentoInput('');
		setModalDepartamento(false);
	};

	////////////////////////////////////////////////////////
	const handleAddResponsavel = () => {
		// Verifica se há um departamento selecionado
		if (!selectedDepartamentoId) {
			alert("Selecione um departamento antes de adicionar um responsável.");
			return;
		}

		// Garante que contacts é um array válido
		const contatos = dados.current.contacts || [];
		if (contatos.length === 0) {
			alert("Nenhum contato disponível.");
			return;
		}

		// Pega o array de departamentos do primeiro contato
		const departamentos = contatos[0]?.departamentos || [];

		// Encontra o departamento selecionado
		const departamentoIndex = departamentos.findIndex(dep => dep.id === parseInt(selectedDepartamentoId));
		if (departamentoIndex === -1) {
			alert("Departamento não encontrado.");
			return;
		}

		// Calcula um novo ID para o responsável
		const responsaveis = departamentos[departamentoIndex]?.responsaveis || [];
		const newResponsavelId = responsaveis.length > 0 ? responsaveis[responsaveis.length - 1].id + 1 : 1;

		// Cria o novo responsável
		const newResponsavel = {
			id: newResponsavelId,
			nome: responsavelInputNome,
			email: responsavelInputEmail,
			telefone: responsavelInputTel
		};

		// Adiciona o novo responsável ao departamento
		departamentos[departamentoIndex].responsaveis.push(newResponsavel);

		// Atualiza a estrutura de dados
		set_dados(prevDados => ({
			...prevDados,
			contacts: prevDados.contacts ? [{
				...prevDados.contacts[0],
				departamentos: [...departamentos]
			}] : []
		}));

		// Limpa os inputs e fecha o modal
		setResponsavelInputNome('');
		setResponsavelInputEmail('');
		setResponsavelInputTel('');
		setModalResponsavel(false);

	};

	const handleRemoveDepartamento = (departamentoId) => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Filter out the departamento with the specified ID
		const updatedDepartamentos = dados.current.contacts[0].departamentos.filter(
			(departamento) => departamento.id !== departamentoId
		);

		// Update the dados.current and data_interface
		dados.current.contacts[0].departamentos = updatedDepartamentos;

	};

	const mostrarDetalhes = (departamentoId) => {
		setModalDetalhes(true);
		const departamento = dados.current.contacts[0].departamentos.find(depart => depart.id === departamentoId);
		if (departamento) {
			setSelectedDepartamento(departamento);
		}
	};

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {
					// node.submenu.forEach(subitem => {
					for await (let subitem of node.submenu) {

						let name_aux = name.split('_')
						name_aux.pop()
						name_aux = name_aux.join('_')

						if (subitem.path === name || subitem.path.includes(name_aux)) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
								if (aux.identificacao !== true) {
									aux.identificacao = subitem.identificacao
								}
								if (aux.naturalidade !== true) {
									aux.naturalidade = subitem.naturalidade
								}
								if (aux.interlocutores !== true) {
									aux.interlocutores = subitem.interlocutores
								}
								if (aux.fiscal !== true) {
									aux.fiscal = subitem.fiscal
								}
								if (aux.associacao !== true) {
									aux.associacao = subitem.associacao
								}
								if (aux.funcoes !== true) {
									aux.funcoes = subitem.funcoes
								}
								if (aux.configuracoes !== true) {
									aux.configuracoes = subitem.configuracoes
								}
							}
							else {
								aux = {
									create: subitem.create,
									edit: subitem.edit,
									view: true,
									remove: subitem.remove,

									identificacao: subitem.identificacao,
									naturalidade: subitem.naturalidade,
									interlocutores: subitem.interlocutores,
									fiscal: subitem.fiscal,
									associacao: subitem.associacao,
									funcoes: subitem.funcoes,
									configuracoes: subitem.configuracoes
								}
							}

							set_dados(permissions.current = aux)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			// sidebar.forEach(node => {
			for await (let node of sidebar) {

				let name_aux = name.split('_')
				name_aux.pop()
				name_aux = name_aux.join('_')


				if (node.path === name || node.path.includes(name_aux)) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					// set_permissions({ edit: node.edit, view: true, remove: node.remove })
					set_dados(permissions.current = aux)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	useEffect(() => {

		(async () => {

			// Vai buscar o tipo de utilizador
			const fetch_tipo_utilizadores = async () => {
				try {

					let res_9 = await reqGET(Hosts.SIMCore_API + '/entities/special/' + getTokenInfo().companycode + '/*');
					let aux_9 = res_9.data.filter(el => el.info.group == !undefined && el.info.group === true)
					set_dados(entity_list.current = aux_9)

					let res_ = await reqGET(Hosts.SIMCore_API + '/entities/profiles/' + getTokenInfo().companycode);
					setUserTypesEntities(res_.data)
					set_dados(entity_profiles.current = res_.data)
					//console.log('entity_profiles.current', entity_profiles.current)

					const res = await reqGET(Hosts.SIMCore_API + '/profiles/' + getTokenInfo().companycode);
					setUserTypes(res.data); // Armazena os tipos de utilizadores no estado
					//console.log("Tipos de utilizador", res.data)
					set_dados(app_profiles.current = res.data)

					let res_1 = await fetch_entity_attributes('entity_category')
					if (res_1.length > 0) {
						res_1 = order_array(res_1)

						let res_aux_1 = []
						for await (let el of res_1) {
							res_aux_1.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_category.current = res_aux_1)
					}
					let res_2 = await fetch_entity_attributes('entity_type')
					if (res_2.length > 0) {
						res_2 = order_array(res_2)

						let res_aux_2 = []
						for await (let el of res_2) {
							res_aux_2.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_type.current = res_aux_2)
					} let res_3 = await fetch_entity_attributes('entity_nature')
					if (res_3.length > 0) {
						res_3 = order_array(res_3)

						let res_aux_3 = []
						for await (let el of res_3) {
							res_aux_3.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_nature.current = res_aux_3)
					}
					let res_6 = await fetch_entity_attributes('entity_relation')
					if (res_6.length > 0) {
						res_6 = order_array(res_6)

						let res_aux_6 = []
						for await (let el of res_6) {
							res_aux_6.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_relation.current = res_aux_6)
					}

					let res_7 = await fetch_entity_attributes('entity_dimension')
					if (res_7.length > 0) {
						res_7 = order_array(res_7)

						let res_aux_7 = []
						for await (let el of res_7) {
							res_aux_7.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_dimension.current = res_aux_7)
					}

					let res_8 = await fetch_entity_attributes('entity_sector')
					if (res_8.length > 0) {
						res_8 = order_array(res_8)

						let res_aux_8 = []
						for await (let el of res_8) {
							res_aux_8.push({
								id: el.id,
								label: el.name,
								parent: el.parent
							})
						}
						set_dados(entity_sector.current = res_aux_8)
					}


					console.log('AKI2', JSON.parse(JSON.stringify(dados.current)))



					if (dados.current.info.attributes === undefined) {
						dados.current.info.attributes = {}
					}

					set_dados(dados.current.info.attributes['entity_category'] = '2')

					if (parseInt(dados.current.info.attributes['entity_type']) === 5 || (parseInt(dados.current.info.attributes['entity_type']) === 14 && parseInt(dados.current.info.attributes['entity_nature']) === 15)) {
						setColetivaOrIndividual(false)
					}
					else {
						setColetivaOrIndividual(true)
					}

					if (dados.current.info.attributes.entity_type !== undefined && dados.current.info.attributes.entity_type !== '') {
						set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(dados.current.info.attributes.entity_type)))
					}

					set_dados(entity_type_filter.current = entity_type.current.filter(el => parseInt(el.parent) === parseInt('2')))
					set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.parent) === parseInt('2')))
					set_dados(entity_relation_filter.current = entity_relation.current.filter(el => parseInt(el.parent) === parseInt('2')))
					set_dados(entity_dimension_filter.current = entity_dimension.current.filter(el => parseInt(el.parent) === parseInt('2')))
					set_dados(entity_sector_filter.current = entity_sector.current.filter(el => parseInt(el.parent) === parseInt('2')))



					console.log('AKI3', JSON.parse(JSON.stringify(dados.current)))


				} catch (error) {
					console.error("Erro ao buscar os tipos de utilizadores:", error);
				}
			};

			/*
			const fetch_departamentos = async () => {
				try {
				const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);    
					const departamentoOptions = res.data.map(departamento => ({
						id: departamento.id,
						name: departamento.info.name
					}));
					console.log('Departamentos', departamentoOptions);
					setDepartamentos(departamentoOptions);
	
				} catch (error) {
					console.error("Erro ao buscar os tipos de utilizadores:", error);
				}
			};
			*/

			//fetch_departamentos();
			console.log('AQUI0', JSON.parse(JSON.stringify(dados.current)))
			await fetch_tipo_utilizadores();
			console.log('AQUI1', JSON.parse(JSON.stringify(dados.current)))
			await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })
			console.log('AQUUI2', permissions.current)
			if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

				for await (let el of getTokenInfo().entity_profile) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
				}

			}

			console.log('AQUI3', JSON.parse(JSON.stringify(dados.current)))

			setLoading(false);

		})()

	}, [pathname]);

	/////////////////////////////////////////////////////////////////////////////////////////////////////

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				set_dados(dados.current = res.data[0]);
				console.log('Data', res)
				if (res?.data[0]?.info?.departamento?.software !== undefined) {
					setSelectedSoftware(res.data[0].info.departamento.software || []);
				}

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}

	////////////////////////////////////////////// VAI BUSCAR O TIPO DE UTILIZADOR /////////////////////////////////////

	const checkDepartmento = (id) => {
		// Verifica se 'dados.current' e 'dados.current.info.departamento' existem
		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			return dados.current.info.departamento.some(el => el.id === id);
		}
		return false; // Retorna false se não houver departamentos associados
	};

	const escolheDepartamentos = (id) => {
		let updatedSelecionado;

		if (!Array.isArray(dados.current.info.departamento)) {
			dados.current.info.departamento = [];
		}

		if (checkDepartmento(id)) {
			updatedSelecionado = dados.current.info.departamento.filter(dept => dept.id !== id);
		} else {
			const selectedDept = departamentos.find(dept => dept.id === id);
			if (selectedDept) {
				updatedSelecionado = [...dados.current.info.departamento, selectedDept];
			}
		}

		dados.current.info.departamento = updatedSelecionado;
		set_dados(dados.current);
		setDepartamentoSelecionado(updatedSelecionado);
	};

	const checkSoftware = (departmentId, softwareId) => {
		if (selectedSoftware[departmentId]?.includes(softwareId)) {
			return true;
		}

		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			const department = dados.current.info.departamento.find(dept => dept.id === departmentId);

			if (department && Array.isArray(department.software)) {
				return department.software.includes(softwareId);
			}
		}

		return false;
	};

	const escolheSoftware = (departmentId, softwareId) => {
		setSelectedSoftware(prev => {
			const departmentSoftware = prev[departmentId] || [];
			const updatedDepartmentSoftware = departmentSoftware.includes(softwareId)
				? departmentSoftware.filter(id => id !== softwareId)
				: [...departmentSoftware, softwareId];

			return {
				...prev,
				[departmentId]: updatedDepartmentSoftware
			};
		});
	};

	/*

	const removeSoftware = (departamentoId, softwareId) => {
		setDepartamentos(prevDepartamentos =>
			prevDepartamentos.map(departamento =>
				departamento.id === departamentoId
					? {
						...departamento,
						software: departamento.software.filter(software => software.id !== softwareId)  // Remove the software by id
					}
					: departamento
			)
		);
	};	
	
	const checkSoftware = (id) => {
		// Verify if 'dados.current' and 'dados.current.software' exist
		if (dados.current && Array.isArray(dados.current.software)) {
			return dados.current.software.some(el => el.id === id);
		}
		return false; // Return false if there are no software items associated
	};

	// Function to select or deselect a software
	const escolheSoftware = (id) => {
		let updatedSelecionado;

		// Initialize software as an array if it's not already one
		if (!Array.isArray(dados.current.software)) {
			dados.current.software = [];
		}

		if (checkSoftware(id)) {
			// If the software is already selected, remove it
			updatedSelecionado = dados.current.software.filter(soft => soft.id !== id);
		} else {
			// Find the selected software by id and add it
			const selectedSoftware = softwares.find(soft => soft.id === id);
			if (selectedSoftware) {
				updatedSelecionado = [...dados.current.software, selectedSoftware];
			}
		}

		// Update the software in dados and set the selected software state
		dados.current.software = updatedSelecionado;
		set_dados(dados.current);
		setSoftwareSelecionado(updatedSelecionado); // Update the state with the new software list
	};
	*/

	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	useEffect(() => {




		console.log('##### AKI1', JSON.parse(JSON.stringify(dados.current)))


		//set_lang('pt')
		//set_lang_id('1')

		//get_fact_legacy_info()
		//get_fact_legacy_info()

		if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
			change_lang('pt')
		}
		else {
			set_lang(localStorage.getItem('lang'))
			console.log("estamos a alterar para", lang)
		}


	}, [props])

	useEffect(() => {




		console.log('!!!!!! AKI1', JSON.parse(JSON.stringify(dados.current)))

		if (!Array.isArray(dados.current.info.relacao)) {
			dados.current.info.relacao = [];
		}
	}, []);

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)





		console.log('CDCD CDCD AKI1', JSON.parse(JSON.stringify(dados.current)))
		console.log('CDCD CDCD AKI1', JSON.parse(JSON.stringify(dados.current)))

	}

	const fetch_entity_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				let aux = {
					id: el.id,
					name: translate(el.info.name, 'pt'),
					type: el.info.type,
					parent: el.info.parent
				}

				result.push(aux)
			}

			if (type === 'entity_relation') {
				set_dados(entity_relation_raw.current = res.data)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props


	useEffect(() => {





		console.log('------ AKI1', JSON.parse(JSON.stringify(dados.current)))

		clean_data();
		obter_paises_em_pt(set_countries);

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				//console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)

					}
					else {
						set_show_district_city_village('d-none')

					}
				})


				return
			}
		}
		catch {

			clean_data()



			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const fetch_departamentos = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
			//console.log("Departamento:", res);
			const departamentoOptions = res.data.map(departamento => ({
				id: departamento.id,
				name: departamento.info.name,
				software: departamento.info.selectedTypes
			}));
			setDepartamentos(departamentoOptions);
			//console.log("Departamento:", departamentoOptions);
		} catch (error) {
			console.error("Erro ao buscar os departamentos:", error);
		}
	};

	// Fetch colaboradores
	const fetch_colaboradores = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Colaborador`);
			//console.log("Colaboradores:", res);	
			const colaboradoresOptions = res.data.map(colaborador => ({
				id: colaborador.id,
				name: colaborador.name,
				departamento: colaborador.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: colaborador.email
			}));
			//console.log("Colaboradores:", colaboradoresOptions);
			setAllResponsaveis(colaboradoresOptions);
		} catch (error) {
			console.error("Erro ao buscar os colaboradores:", error);
		}
	};

	const fetch_teamleaders = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/TeamLeader`);
			//console.log("TeamLeaders:", teamLeaderOptions);
			const teamLeaderOptions = res.data.map(teamLeader => ({
				id: teamLeader.id,
				name: teamLeader.name,
				departamento: teamLeader.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: teamLeader.email
			}));
			setTeamLeader(teamLeaderOptions);
			//console.log("TeamLeaders:", teamLeaderOptions);
		} catch (error) {
			console.error("Erro ao buscar os TeamLeaders:", error);
		}
	};

	// Group colaboradores by departamento
	// Group colaboradores and team leaders by departamento
	const groupColaboradoresByDepartamento = (colaboradores, teamLeaders) => {
		const departamentoMap = new Map();

		const addToDepartamento = (dep, type, person) => {
			if (!departamentoMap.has(dep.id)) {
				//console.log(`Creating new department entry for ID: ${dep.id}, Name: ${dep.name}`);
				departamentoMap.set(dep.id, {
					name: dep.name,
					colaboradores: [],
					teamLeaders: []
				});
			}
			//console.log(`Adding ${type.slice(0, -1)}:`, person, `to department ID: ${dep.id}`);
			departamentoMap.get(dep.id)[type].push(person);
		};

		//console.log("Processing colaboradores...");
		colaboradores.forEach(colaborador => {
			//console.log("Processing colaborador:", colaborador.name);
			if (colaborador.departamento && Array.isArray(colaborador.departamento)) {
				colaborador.departamento.forEach(dep => {
					//console.log(`Colaborador belongs to department ID: ${dep.id}, Name: ${dep.name}`);
					addToDepartamento(dep, "colaboradores", {
						id: colaborador.id,
						name: colaborador.name,
						email: colaborador.email
					});
				});
			} else {
				console.warn(`Colaborador ${colaborador.name} has no valid departamento data.`);
			}
		});

		//console.log("Processing team leaders...");
		teamLeaders.forEach(teamLeader => {
			//console.log("Processing team leader:", teamLeader.name);
			if (teamLeader.departamento && Array.isArray(teamLeader.departamento)) {
				teamLeader.departamento.forEach(dep => {
					//console.log(`Team leader belongs to department ID: ${dep.id}, Name: ${dep.name}`);
					addToDepartamento(dep, "teamLeaders", {
						id: teamLeader.id,
						name: teamLeader.name,
						email: teamLeader.email
					});
				});
			} else {
				console.warn(`Team leader ${teamLeader.name} has no valid departamento data.`);
			}
		});

		//console.log("Converting Map to object...");
		const result = Array.from(departamentoMap.entries()).reduce((acc, [id, data]) => {
			//console.log(`Finalizing department ID: ${id}, Data:`, data);
			acc[id] = data;
			return acc;
		}, {});

		//console.log("Final grouped data:", result);
		return result;
	};

	// Fetch both departamentos and colaboradores and process the data
	const fetchAndDisplayData = async () => {
		await fetch_departamentos();
		await fetch_colaboradores();
		await fetch_teamleaders();
	};

	useEffect(() => {





		console.log('????? AKI1', JSON.parse(JSON.stringify(dados.current)))

		fetchAndDisplayData();
	}, []);

	useEffect(() => {




		console.log('DDDD AKI1', JSON.parse(JSON.stringify(dados.current)))

		if (dados.current.info.departamento) {
			const initialSelections = {};
			dados.current.info.departamento.forEach(department => {
				initialSelections[department.id] = department.software
					? department.software.map(software => software.id)
					: [];
			});
			setSelectedSoftware(initialSelections);
		}
	}, [dados.current.info.departamento]);

	const groupedData = groupColaboradoresByDepartamento(allResponsaveis, teamLeader);

	const handleSubmit = async (e) => {
		e.preventDefault();

		dados.current.profile.id = '';
		dados.current.profile.name = 'Empresa';
		dados.current.info.entity_type = '2';
		dados.current.info.entity = [{ id: '2', label: 'Externa' }];
		dados.current.info.birthday = dados.current.info.birthday || null;
		dados.current.info.username = dados.current.info.username || dados.current.info.razaoSocial;

		const departamentosToSubmit = Array.isArray(dados.current.info.departamento)
			? dados.current.info.departamento.map(departamento => {
				const selectedSoftwareIds = selectedSoftware[departamento.id] || [];

				const softwareArray = Array.isArray(departamento.software)
					? departamento.software
						.filter(software => selectedSoftwareIds.includes(software.id))
						.map(software => ({
							id: software.id,
							nome: software.nome,
						}))
					: [];

				return {
					id: departamento.id,
					name: departamento.name,
					software: softwareArray,
				};
			})
			: [];

		dados.current.info.departamento = departamentosToSubmit;
		console.log("Data to be submitted:", dados.current);

		const requestMethod = is_edit ? reqPUT : reqPOST;
		const apiRoute = api_crud_route;

		if (dados.current.info.name === undefined || dados.current.info.name === '') {
			Swal.fire('O campo Nome é obrigatório.', '', 'info');
			return
		}

		if (dados.current.info.attributes.entity_category === undefined || dados.current.info.attributes.entity_category === '') {
			Swal.fire('O campo Tipo de Utilizador é obrigatório.', '', 'info');
		}

		try {
			const response = await requestMethod(apiRoute, dados.current);
			console.log("Response:", response);
			set_new_password('');
			set_confirm_password('');

			files_image.forEach(async (el_image) => {
				if (el_image !== null) {
					if (el_image.files.length > 0) {
						await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
					}
				}
			})
			set_files_image([])
			set_image_base64([])
			// set_photo_base64('')

			files_doc.forEach(async (el_doc) => {
				if (el_doc !== null) {
					await uploadFilesDoc(el_doc.files, el_doc.order, 'cv', el_doc.langid, el_doc.lang)
				}
			})
			set_files_doc([])
			set_files_doc_name([])

			if (is_edit) {
				Swal.fire('', 'Atualizado com sucesso', 'success');
			}
			else {
				props.history.push(endpoints.list);
				// window.location.reload();
			}

			//props.history.push(endpoints.list);
			// window.location.reload();
		} catch (error) {
			console.error("Submission error:", error);
			const errorMsg = is_edit ? language[lang].edit_error : language[lang].insert_error;
			Swal.fire(errorMsg, '', 'info');
		}
	};

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							/* alert(res.status === 200 ?
								'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};


	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		// filesArray.forEach(async (v, k) => {
		for await (let v of filesArray) {
			let ext = v.name.split('.')[1]
			if (((ext === "jpeg" || ext === "jpg" || ext === "png")) && (v.size < 10485760)) {

				console.log('1')
				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				console.log('2')
				await convertBase64(v)
					.then((base64) => {
						// console.log('base64', base64)

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_logo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				console.log('3')

				if (filesArray.length === (k + 1)) {
					//set_dados(dados.current,)
					//setRefresh(refresh + 1)
					setRefresh(refresh + parseInt(v.size) + k)
				}


				console.log('4')

			}
			else {
				Swal.fire('', language[lang].upload_image_error + v.name, 'info')
			}

			k++
		}
		// });

		console.log('storedFiles', storedFiles)


		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {
		set_dados(prevDados => ({
			...prevDados,
			info: {
				...prevDados.info,
				foto: []
			}
		}));
	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		console.log('api_crud_base', api_crud_base)
		console.log('formData', formData)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'photo') {
					dados.current.info.foto = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}
				else if (type === 'cv') {
					dados.current.info.cv = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info[name] = value);

		if (name === 'razaoSocial') {
			dados.current.info.username = value;
		}

		if (name === 'type') {
			dados.current.profile.name = value;
		}

		if (!is_edit && name === 'vat') {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type);
			}
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		console.log('######################################')

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const change_entity_attributes = (e) => {
		const { name, value } = e.target;

		if (name === 'entity_category') {
			set_dados(entity_type_filter.current = entity_type.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_relation_filter.current = entity_relation.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_dimension_filter.current = entity_dimension.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_sector_filter.current = entity_sector.current.filter(el => parseInt(el.parent) === parseInt(value)))

			set_dados(entity_nature_filter.current = [])
			set_dados(dados.current.info.relacao = [])

		}

		else if (name === 'entity_type') {
			set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(value)))

			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_type) === parseInt(value)))

			if (parseInt(value) === 5) {
				setColetivaOrIndividual(false)
			} else {
				setColetivaOrIndividual(true)
			}
		}

		else if (name === 'entity_nature') {
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_nature) === parseInt(value)))

			if (parseInt(dados.current.info.attributes['entity_type']) === 5 || (parseInt(dados.current.info.attributes['entity_type']) === 14 && parseInt(value) === 15)) {
				setColetivaOrIndividual(false)
			}
			else {
				setColetivaOrIndividual(true)
			}
		}

		if (dados.current.info.attributes === undefined) {
			dados.current.info.attributes = {}
		}

		set_dados(dados.current.info.attributes[name] = value)

	}

	const handle_entity_relation = (e) => {
		const { value, checked } = e.target;

		if (!dados.current.info.relacao) {
			dados.current.info.relacao = [];
		}

		console.log('value', value)

		const selectedOption = entity_relation.current.find(option => parseInt(option.id) === parseInt(value));
		console.log(selectedOption)
		if (checked && selectedOption) {
			if (!dados.current.info.relacao.some(item => parseInt(item) === parseInt(value))) {
				set_dados(dados.current.info.relacao.push(selectedOption.id))
			}
		}
		else {
			set_dados(dados.current.info.relacao = dados.current.info.relacao.filter(item => parseInt(item) !== parseInt(value)))
		}

		console.log('dados.current.info.relacao', dados.current.info.relacao)
	};

	const traduzEntidade = (profile, lang) => {
		const entidadesMapeadas = {
			en: {
				'Interna': 'Internal',
				'Externa': 'External',
			},
			pt: {
				'Internal': 'Interna',
				'External': 'Externa',
			},
		};
		return entidadesMapeadas[lang]?.[profile] || profile;
	};

	const traduzTipoEntidade = (profile, lang) => {
		const tipoEntidadesMapeadas = {
			en: {
				'Pessoal': 'Staff',
				'Empresarial': 'Business',
			},
			pt: {
				'Staff': 'Pessoal',
				'Business': 'Empresarial',
			},
		};
		return tipoEntidadesMapeadas[lang]?.[profile] || profile;
	};

	const traduzirTipoRelacao = (tipoRelacao, lang) => {
		const tiposRelacaoMapeados = {
			en: {
				'Agente': 'Agent',
				'Cliente': 'Client',
				'Colaborador': 'Collaborator',
				'Distribuidor': 'Distributor',
				'Fornecedor': 'Supplier',
				'Investidor': 'Investor',
				'Parceiro': 'Partner',
				'Sócio': 'Partner/Associate',
				'Outro': 'Other',
			},
			pt: {
				'Agent': 'Agente',
				'Client': 'Cliente',
				'Collaborator': 'Colaborador',
				'Distributor': 'Distribuidor',
				'Supplier': 'Fornecedor',
				'Investor': 'Investidor',
				'Partner': 'Parceiro',
				'Partner/Associate': 'Sócio',
				'Other': 'Outro',
			},
		};
		return tiposRelacaoMapeados[lang]?.[tipoRelacao] || tipoRelacao;
	};

	const traduzPerfil = (profile, lang) => {
		const profilesMapeados = {
			en: {
				'Administrador': 'Admin',
				'Colaborador': 'Collaborator',
				'Desenvolvedor': 'Developer',
				'Empresa': 'Company',
				'Entidade': 'Entity',
				'Gestor de Conteúdos': 'Content Manager',
				'TeamLeader': 'Team Leader',
			},
			pt: {
				'Admin': 'Administrador',
				'Collaborator': 'Colaborador',
				'Developer': 'Desenvolvedor',
				'Company': 'Empresa',
				'Entity': 'Entidade',
				'Content Manager': 'Gestor de Conteúdos',
				'Team Leader': 'TeamLeader',
			},
		};
		return profilesMapeados[lang]?.[profile] || profile;
	};

	useEffect(() => {
		if (is_edit) {
			setShowOverview(true);
			setShowFunctions(false);
		}
	}, [is_edit]);

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0 d-flex justify-content-sm-between p-4 ">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0 text-nowrap">{language[lang].personal_data}</h3>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body p-4">
												<div className='tab-content'>
													<div className="d-flex flex-row flex-wrap justify-content-end gap-2 border-bottom pb-1 mb-3 ">
														{permissions.current != null && permissions.current.identificacao !== null && permissions.current.identificacao && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showOverView ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(true); //true
																	setShowNat(false);
																	setShowFiscalData(false);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																	setShowInter(false);
																}}
															>
																{language[lang].identification}
															</button>
														)}
														{permissions.current != null && permissions.current.naturalidade !== null && permissions.current.naturalidade && (coletivaOrIndividual === false) && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showNat ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(true);//true
																	setShowFiscalData(false);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																	setShowInter(false);
																}}
															>
																{language[lang].naturalidade}
															</button>
														)}
														{permissions.current != null && permissions.current.interlocutores !== null && permissions.current.interlocutores && (coletivaOrIndividual === true) && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showInter ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(false);
																	setShowFiscalData(false);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																	setShowInter(true);//true
																}}
															>
																{language[lang].interlocutores}
															</button>
														)}
														{permissions.current != null && permissions.current.fiscal !== null && permissions.current.fiscal && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showFiscalData ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(false);
																	setShowFiscalData(true);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																	setShowInter(false);
																}}

															>
																{language[lang].dados_fiscais}
															</button>
														)}
														{permissions.current != null && permissions.current.associacao !== null && permissions.current.associacao && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showContract ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(false);
																	setShowContract(true); //true
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowFiscalData(false);
																	setShowInter(false);
																}}

															>
																{language[lang].segmentacao}
															</button>
														)}
														{permissions.current != null && permissions.current.funcoes !== null && permissions.current.funcoes && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showFunctions ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowFiscalData(false);
																	setShowNat(false);
																	setShowFunctions(true); //true
																	setShowSettings(false);
																	setShowContract(false);
																	setShowInter(false);
																}}

															>
																{language[lang].functions}
															</button>
														)}
														{permissions.current != null && permissions.current.configuracoes !== null && permissions.current.configuracoes && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showSettings ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowFiscalData(false);
																	setShowNat(false);
																	setShowFunctions(false);
																	setShowSettings(true); //true
																	setShowContract(false);
																	setShowInter(false);
																}}
															>
																{language[lang].settings}
															</button>
														)}
													</div>

													{showOverView && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
																<input
																	type="text"
																	name="name"
																	value={dados.current.info.name}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].name_placeholder}
																	onChange={handle_change_info}
																	required
																/>
															</div>

															{(coletivaOrIndividual === true) && (
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].razao_social}</label>
																	<input
																		type="text"
																		name="razaoSocial"
																		value={dados.current.info.razaoSocial || ''}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder="Razão Social"
																		onChange={handle_change_info}
																	/>
																</div>
															)}
														</div>
													)}

													{showOverView && (
														<div className="row mb-4 mb-4">
															{(dados.current.info.type.some(option => option.label === 'Empresarial') || selectedTipoCliente === '2') && (
																<div className="col-md-4 d-none">
																	<label className="fs-6 fw-bold mb-2">{language[lang].tlf}</label>
																	<PhoneInput
																		defaultCountry="PT"
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].tlf_placeholder}
																		value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
																		onChange={e => set_dados(dados.current.contacts[0].phone = e)}
																	/>

																</div>
															)}

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].tlm}</label>
																<PhoneInput
																	defaultCountry="PT"
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].tlm_placeholder}
																	value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
																	onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{coletivaOrIndividual === true
																		? language[lang].constituicao
																		: language[lang].birthday}
																</label>
																<input type="date" name="birthday" value={dados.current.info.birthday !== '' ? dados.current.info.birthday : ''}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showOverView && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].email}</label>
																<input
																	type="email"
																	pattern={pattern_email}
																	name="email"
																	value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].email_placeholder}
																	onChange={handle_change_contacts} />
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].url}</label>
																<input
																	type="text"
																	name="url"
																	value={dados.current.info.url != undefined && dados.current.info.url != '' ? dados.current.info.url : dados.current.contacts[0].url}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].url_placeholder}
																	onChange={handle_change_contacts} />
															</div>

															{(dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') && (
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].profile}</label>
																	<select
																		name="profile"
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		onChange={handleUserTypeChange}
																		value={dados.current.profile.name}
																	>
																		<option value="">{language[lang].choose_profile}</option>
																		{userTypes.map((userType) => (
																			<option key={userType.name} value={userType.name}>
																				{traduzPerfil(userType.name, lang)}
																			</option>
																		))}
																	</select>
																</div>
															)}
														</div>
													)}

													{showOverView && (
														<div>
															<div className="row mb-4">
																<div className="col-md-8 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].morada}</label>
																	<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} />
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].local}</label>
																	<input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].postal_code}</label>
																	<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].village}</label>
																	<Select
																		className="div-select"
																		options={villages}
																		name="freguesia"
																		value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
																		placeholder={language[lang].village_placeholder}
																		onChange={change_village}
																		styles={custom_select_styles}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].city}</label>
																	<Select
																		className="div-select"
																		options={cities}
																		name="concelho"
																		value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
																		placeholder={language[lang].city_placeholder}
																		onChange={change_city}
																		styles={custom_select_styles}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].district}</label>
																	<Select
																		className="div-select"
																		options={districts}
																		name="distrito"
																		value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
																		placeholder={language[lang].district_placeholder}
																		onChange={change_district}
																		styles={custom_select_styles}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].country}</label>
																	<Select
																		className="div-select"
																		options={countries}
																		name="pais"
																		value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
																		placeholder={language[lang].country_placeholder}
																		onChange={change_country}
																		styles={custom_select_styles}
																	/>
																</div>
															</div>
														</div>
													)}

													{showOverView && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].contribuinte}
																</label>
																<input type="text"
																	pattern={pattern_vat}
																	minLength="3"
																	inputMode='numeric'
																	name="numero_contribuinte"
																	value={dados.current.info.numero_contribuinte}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].contribuinte_placeholder}
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].arquivo}</label>
																<input type="text"
																	name="arquivo"
																	value={dados.current.info.arquivo}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].arquivo_placeholder}
																	onChange={handle_change_info} />
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].validade_contribuinte}
																</label>
																<input
																	type="text"
																	minLength="5"
																	maxLength="5"
																	pattern="\d{2}/\d{2}"
																	inputMode="numeric"
																	name="validade_contribuinte"
																	value={dados.current.info.validade_contribuinte}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].validade_contribuinte_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showOverView && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].sexo}
																</label>
																<select
																	name="sexo"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																	value={
																		dados?.current?.info?.sexo !== undefined &&
																			dados?.current?.info?.sexo !== null
																			? dados.current.info.sexo
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>

																	<option value="2">{language[lang].feminino}</option>
																	<option value="1">{language[lang].masculino}</option>
																	<option value="0">{language[lang].outro}</option>

																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].estado_civil}
																</label>
																<select
																	name="estado_civil"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																	value={
																		dados?.current?.info?.estado_civil !== undefined &&
																			dados?.current?.info?.estado_civil !== null
																			? dados.current.info.estado_civil
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>

																	<option value="0">{language[lang].solteiro}</option>
																	<option value="1">{language[lang].casado}</option>
																	<option value="2">{language[lang].divorciado}</option>
																	<option value="3">{language[lang].viuvo}</option>

																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].habilitacao_literaria}
																</label>
																<select
																	name="habilitacao_literaria"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																	value={
																		dados?.current?.info?.habilitacao_literaria !== undefined &&
																			dados?.current?.info?.habilitacao_literaria !== null
																			? dados.current.info.habilitacao_literaria
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>

																	<option value="0">{language[lang].ensino_basico}</option>
																	<option value="1">{language[lang].ensino_secundario}</option>
																	<option value="2">{language[lang].licenciatura}</option>
																	<option value="3">{language[lang].mestrado}</option>
																	<option value="4">{language[lang].doutoramento}</option>
																	<option value="6">{language[lang].pos_doutoramento}</option>

																</select>
															</div>
														</div>
													)}

													{showOverView && (
														<div className="row mb-4">
															<div className="col-md-8">
																<label className="fs-6 fw-bold mb-2">{language[lang].observacoes}</label>
																<textarea name="observation"
																	value={dados.current.info.observation}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	rows="4"
																	onChange={handle_change_info} />
															</div>
														</div>
													)}

													{showNat && (
														<div>
															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].local}</label>
																	<input
																		type="text"
																		name="localidade"
																		value={dados.current.info.localidade}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].local_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].village}</label>
																	<input
																		type="text"
																		name="village"
																		value={dados.current.info.village}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].village_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].city}</label>
																	<input
																		type="text"
																		name="city"
																		value={dados.current.info.city}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].city_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].district}</label>
																	<input
																		type="text"
																		name="region"
																		value={dados.current.info.region}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].district_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].country}</label>
																	<input
																		type="text"
																		name="country"
																		value={dados.current.info.country}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].country_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>
														</div>
													)}

													{showInter && (
														<div className="row mb-4">
															<div className="card-header border-0" aria-expanded="true" aria-controls="div_departamento_table">
																<div className="card-title m-0 d-flex justify-content-end align-items-center">
																	{dados.current.contacts?.[0]?.departamentos?.length > 0 && (
																		<button
																			type="button"
																			onClick={() => setModalResponsavel(true)}
																			className="btn rounded-pill btn-secondary py-1 px-2 btn-sm me-2"
																			style={{ fontSize: '0.85rem' }}
																		>
																			{language[lang].adicionar_entidade}
																		</button>
																	)}

																	<button
																		type="button"
																		onClick={() => setModalDepartamento(true)}
																		className="btn rounded-pill btn-primary py-1 px-2 btn-sm"
																		style={{ fontSize: '0.85rem' }}
																	>
																		{language[lang].adicionar_departamento}
																	</button>
																</div>
															</div>

															<div className="table-responsive mt-3">
																<div className={"div-table"}>
																	<div className='table-body interlocutores-list table-responsive'>
																		<table className="table interlocutores-list table-hover table-bordered align-middle">
																			<thead className="text-center align-middle">
																				<tr>
																					<th className='p-3'>{language[lang].departamento}</th>
																					<th className='p-3'>{language[lang].responsaveis}</th>
																					<th className='p-3'>{language[lang].email}</th>
																					<th className='p-3'>{language[lang].tlm}</th>
																					<th className='p-3'></th>
																				</tr>
																			</thead>
																			<tbody>
																				{dados.current.contacts?.[0]?.departamentos?.map((departamento, index) => (
																					<tr key={index}>
																						<td style={{ cursor: 'pointer' }} onClick={() => mostrarDetalhes(departamento.id)}>
																							<ul className='list-unstyled'>
																								{departamento.name}
																							</ul>
																						</td>
																						<td style={{ cursor: 'pointer' }} onClick={() => mostrarDetalhes(departamento.id)}>
																							<ul className='list-unstyled'>
																								{departamento.responsaveis?.map((responsavel) => (
																									<li key={responsavel.id}>
																										<span>{responsavel.nome}</span>
																									</li>
																								))}
																							</ul>
																						</td>
																						<td style={{ cursor: 'pointer' }} onClick={() => mostrarDetalhes(departamento.id)}>
																							<ul className='list-unstyled'>
																								{departamento.responsaveis?.map((responsavel) => (
																									<li key={responsavel.id}>
																										<span>{responsavel.email !== '' ? responsavel.email : "-"}</span>
																									</li>
																								))}
																							</ul>
																						</td>
																						<td style={{ cursor: 'pointer' }} onClick={() => mostrarDetalhes(departamento.id)}>
																							<ul className='list-unstyled'>
																								{departamento.responsaveis?.map((responsavel) => (
																									<li key={responsavel.id}>
																										<span>{responsavel.telefone !== '' ? responsavel.telefone : '-'}</span>
																									</li>
																								))}
																							</ul>
																						</td>
																						<td className='text-center'>
																							<button
																								onClick={(e) => { e.stopPropagation(); handleRemoveDepartamento(departamento.id); }}
																							>
																								<i className="bi bi-trash3 me-2"></i>
																							</button>
																						</td>
																					</tr>
																				))}
																			</tbody>
																			<tfoot>
																				<tr>
																					<td colSpan="5">
																						{language[lang].total_departamentos}: {dados.current.contacts?.[0]?.departamentos?.length || 0}
																					</td>
																				</tr>
																			</tfoot>
																		</table>
																	</div>
																</div>
															</div>

															<div className="card-body">
																<div className="card-body p-4">
																	<div className='row mb-6'>
																		{modalDepartamento && (
																			<div className="modal show" style={{ display: 'block', marginTop: '5%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
																				<div className="modal-dialog modal-lg">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">📝 {language[lang].adicionar_departamento}</h5>
																							<button type="button" className="close" onClick={() => setModalDepartamento(false)}>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="form-group">
																								<label className="fs-6 fw-bold mb-2 d-block">
																									{language[lang].name_departamento}
																								</label>
																								<div className="col-4">
																									<input
																										type="text"
																										value={departamentoInput}
																										className="form-control"
																										placeholder="Nome do departamento"
																										onChange={(e) => setDepartamentoInput(e.target.value)}
																									/>
																								</div>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => setModalDepartamento(false)}>
																								{language[lang].close}
																							</button>
																							<button type="button" className="btn btn-primary" onClick={handleAddDepartamento}>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}

																		{modalResponsavel && (
																			<div className="modal show" style={{ display: 'block', marginTop: '5%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
																				<div className="modal-dialog modal-lg">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">📝 {language[lang].adicionar_entidade}</h5>
																							<button type="button" className="close" onClick={() => setModalResponsavel(false)}>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="row mb-4">
																								<div className="col-md-6">
																									<div className="form-group mb-3">
																										{dados.current.contacts[0].departamentos.length > 0 ? (
																											<>
																												<label className="fs-5 fw-bold mb-1 d-block">{language[lang].departamento}</label>
																												<select
																													value={selectedDepartamentoId}
																													onChange={(e) => setSelectedDepartamentoId(e.target.value)}
																													className="form-select"
																												>
																													<option value="">{language[lang].selec_departamento}</option>
																													{dados.current.contacts[0].departamentos.map((departamento) => (
																														<option key={departamento.id} value={departamento.id}>
																															{departamento.name}
																														</option>
																													))}
																												</select>
																											</>
																										) : (
																											<p className="fs-5 mb-2">{language[lang].no_departamento}</p>
																										)}
																									</div>

																									<div className="form-group mb-3">
																										<label className="fs-5 fw-bold mb-1 d-block">{language[lang].nome_responsavel}</label>
																										<input
																											type="text"
																											value={responsavelInputNome}
																											onChange={(e) => setResponsavelInputNome(e.target.value)}
																											className="form-control"
																											placeholder="Nome do Responsável"
																										/>
																									</div>
																								</div>

																								<div className="col-md-6">
																									<div className="form-group mb-3">
																										<label className="fs-5 fw-bold mb-1 d-block">{language[lang].email}</label>
																										<input
																											type="email"
																											value={responsavelInputEmail}
																											onChange={(e) => setResponsavelInputEmail(e.target.value)}
																											className="form-control"
																											placeholder="Email"
																										/>
																									</div>

																									<div className="form-group mb-3">
																										<label className="fs-5 fw-bold mb-1 d-block">{language[lang].tlf}</label>
																										<input
																											type="tel"
																											value={responsavelInputTel}
																											onChange={(e) => setResponsavelInputTel(e.target.value)}
																											className="form-control"
																											placeholder="Telefone"
																										/>
																									</div>
																								</div>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => setModalResponsavel(false)}>
																								{language[lang].close}
																							</button>
																							<button type="button" className="btn btn-primary" onClick={handleAddResponsavel}>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}

																		{modalDetalhes && selectedDepartamento && (
																			<div
																				className="modal show d-flex justify-content-center align-items-center"
																				style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
																			>
																				<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">✏️ {language[lang].detalhes_departamento}</h5>
																							<button
																								type="button"
																								className="close"
																								onClick={handleCloseModal}
																							>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="mb-3">
																								<label className="w-100">{language[lang].name_departamento}</label>
																								<input
																									type="text"
																									value={selectedDepartamento.name}
																									onChange={(e) =>
																										setSelectedDepartamento({ ...selectedDepartamento, name: e.target.value })
																									}
																									className="form-control mt-2"
																								/>
																							</div>
																							<div className="mb-4" style={{ marginTop: '5%' }}>
																								<label>{language[lang].responsaveis}</label>
																								<div className="mt-2"></div>
																								<ul className="list-unstyled">
																									{selectedDepartamento.responsaveis.map((responsavel, index) => (
																										<li key={responsavel.id} className="mb-3">
																											<div className="d-flex align-items-center">
																												<label className="mr-2">{language[lang].name}:</label>
																												<input
																													type="text"
																													value={responsavel.nome}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].nome = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Nome"
																													style={{ flex: 1, marginRight: '15px' }}
																												/>
																												<label className="mr-2">{language[lang].email}:</label>
																												<input
																													type="email"
																													value={responsavel.email}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].email = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Email"
																													style={{ flex: 1, marginRight: '15px' }}
																												/>
																												<label className="mr-2">{language[lang].tlf}:</label>
																												<input
																													type="tel"
																													value={responsavel.telefone}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].telefone = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Telefone"
																													style={{ flex: 1 }}
																												/>
																												<button
																													type="button"
																													onClick={() => {
																														const updatedResponsaveis = selectedDepartamento.responsaveis.filter((_, i) => i !== index);
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																												>
																													✖️
																												</button>
																											</div>
																										</li>
																									))}
																								</ul>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button
																								type="button"
																								className="btn btn-default"
																								onClick={handleCloseModal}
																							>
																								{language[lang].cancel}
																							</button>
																							<button
																								type="button"
																								className="btn btn-primary"
																								onClick={handleSaveChanges}
																							>
																								{language[lang].save_entidade}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}
																	</div>
																</div>
															</div>

															<div className="card-body p-4">
																{/* 
																<div className="row mb-6">
																	<label className="fs-5 fw-bold mb-2">{language[lang].dep_emp}</label>
																	<div className="col-md-6">
																		<div
																			className="form-control mb-3 mb-lg-0 rounded-0"
																			style={{ height: 'auto', width: '1250px', borderWidth: '1px' }}
																		>
																			{departamentos.length > 0 ? (
																				departamentos.map((departamento) => (
																					<div key={departamento.id} className="form-check">
																						<input
																							type="checkbox"
																							className="form-check-input"
																							id={`departamento-${departamento.id}`}
																							checked={checkDepartmento(departamento.id)}
																							onChange={() => escolheDepartamentos(departamento.id)}
																						/>
																						<label className="form-check-label" htmlFor={`departamento-${departamento.id}`}>
																							{departamento.name}
																						</label>
																						{departamento.software && departamento.software.length > 0 && (
																							<div className="nested-checkboxes ms-4">
																								{departamento.software.map((softwareType) => (
																									<div key={softwareType.id} className="form-check">
																										<input
																											type="checkbox"
																											className="form-check-input"
																											id={`software-${departamento.id}-${softwareType.id}`}
																											checked={checkSoftware(departamento.id, softwareType.id)}
																											onChange={() => escolheSoftware(departamento.id, softwareType.id)}
																											disabled={!checkDepartmento(departamento.id)}
																										/>
																										<label className="form-check-label" htmlFor={`software-${departamento.id}-${softwareType.id}`}>
																											{`Certificação em ${softwareType.nome}`}
																										</label>
																									</div>
																								))}
																							</div>
																						)}
																					</div>
																				))
																			) : (
																				<div>{language[lang].carregar}</div>
																			)}
																		</div>
																	</div>
																</div>
																*/}
															</div>
														</div>
													)}

													{/* Setor & Dimensão */}
													{showContract && (coletivaOrIndividual === true) && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-6 fw-bold mb-2">{language[lang].sector}</label>
																<select
																	name="sector"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_entity_attributes}
																	value={
																		dados?.current?.info?.attributes?.sector !== undefined &&
																			dados?.current?.info?.attributes?.sector !== null
																			? dados.current.info.attributes.sector
																			: ''
																	}

																>
																	<option value="">{language[lang].select}</option>
																	{
																		entity_sector_filter.current !== undefined && entity_sector_filter.current !== null
																			? entity_sector_filter.current.map((option, key) => (
																				<option key={key} value={option.id}>
																					{option.label}
																				</option>
																			))
																			: null
																	}
																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].dimensao}</label>
																<select
																	name="dimension"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_entity_attributes}
																	value={
																		dados?.current?.info?.attributes?.dimension !== undefined &&
																			dados?.current?.info?.attributes?.dimension !== null
																			? dados.current.info.attributes.dimension
																			: ''
																	}

																>
																	<option value="">{language[lang].select}</option>
																	{
																		entity_dimension_filter.current !== undefined && entity_dimension_filter.current !== null
																			? entity_dimension_filter.current.map((option, key) => (
																				<option key={key} value={option.id}>
																					{option.label}
																				</option>
																			))
																			: null
																	}
																</select>
															</div>
														</div>
													)}

													{/* Grau Risco & Fidelização & Sugestões & Satisfação */}
													{showContract && (coletivaOrIndividual === true) && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].grau_risco}
																</label>
																<select
																	name="grau_risco"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={(e) => {
																		dados.current.info.grau_risco = e.target.value;
																		change_entity_attributes(e);
																	}}
																	value={
																		dados?.current?.info?.grau_risco !== undefined &&
																			dados?.current?.info?.grau_risco !== null
																			? dados.current.info.grau_risco
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>
																	<option value="1">{language[lang].reduzido}</option>
																	<option value="2">{language[lang].medio}</option>
																	<option value="3">{language[lang].elevado}</option>
																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].fidelidade}
																</label>
																<select
																	name="fidelidade"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={(e) => {
																		dados.current.info.fidelidade = e.target.value;
																		change_entity_attributes(e);
																	}}
																	value={
																		dados?.current?.info?.fidelidade !== undefined &&
																			dados?.current?.info?.fidelidade !== null
																			? dados.current.info.fidelidade
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>
																	<option value="1">{language[lang].reduzida}</option>
																	<option value="2">{language[lang].media}</option>
																	<option value="3">{language[lang].elevada}</option>
																</select>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === true) && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].satisfacao}
																</label>
																<select
																	name="satisfacao"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={(e) => {
																		dados.current.info.satisfacao = e.target.value;
																		change_entity_attributes(e);
																	}}
																	value={
																		dados?.current?.info?.satisfacao !== undefined &&
																			dados?.current?.info?.satisfacao !== null
																			? dados.current.info.satisfacao
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>
																	<option value="1">{language[lang].insatisfeito}</option>
																	<option value="2">{language[lang].satisfeito}</option>
																	<option value="3">{language[lang].muito_satisfeito}</option>
																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].sugestao}
																</label>
																<select
																	name="sugestao"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={(e) => {
																		dados.current.info.sugestao = e.target.value;
																		change_entity_attributes(e);
																	}}
																	value={
																		dados?.current?.info?.sugestao !== undefined &&
																			dados?.current?.info?.sugestao !== null
																			? dados.current.info.sugestao
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>
																	<option value="3">{language[lang].sim}</option>
																	<option value="2">{language[lang].por_vezes}</option>
																	<option value="1">{language[lang].raramente}</option>
																	<option value="0">{language[lang].nunca}</option>
																</select>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].modalidade}
																</label>
																<select
																	name="modalidade"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																	value={
																		dados?.current?.info?.modalidade !== undefined &&
																			dados?.current?.info?.modalidade !== null
																			? dados.current.info.modalidade
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>

																	<option value="6">{language[lang].atletismo}</option>
																	<option value="5">{language[lang].voleibol}</option>
																	<option value="4">{language[lang].andebol}</option>
																	<option value="3">{language[lang].futsal}</option>
																	<option value="2">{language[lang].basquet}</option>
																	<option value="1">{language[lang].futebol}</option>
																	<option value="0">{language[lang].outro}</option>
																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].numero_interno}
																</label>
																<input type="text"
																	minLength="3"
																	inputMode='numeric'
																	name="numero_interno"
																	value={dados.current.info.numero_interno}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].numero_interno_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].admissao}
																</label>
																<input type="date" name="admissao" value={dados.current.info.admissao !== '' ? dados.current.info.admissao : ''}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].numero_atleta}
																</label>
																<input type="text"
																	minLength="3"
																	inputMode='numeric'
																	name="numero_atleta"
																	value={dados.current.info.numero_atleta}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].numero_atleta_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].entrada_associacao}
																</label>
																<input type="date" name="entrada_associacao" value={dados.current.info.entrada_associacao !== '' ? dados.current.info.entrada_associacao : ''}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].validade_contrato}
																</label>
																<input
																	type="text"
																	minLength="5"
																	maxLength="5"
																	pattern="\d{2}/\d{2}"
																	inputMode="numeric"
																	name="validade_contrato"
																	value={dados.current.info.validade_contrato}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].validade_contrato_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].seguro_acidentes}
																</label>
																<input type="text"
																	name="seguro_acidentes"
																	value={dados.current.info.seguro_acidentes}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].seguro_acidentes_placeholder}
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].data_exames_medicos}
																</label>
																<input type="date" name="data_exames_medicos" value={dados.current.info.data_exames_medicos !== '' ? dados.current.info.data_exames_medicos : ''}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-8">
																<label className="fs-6 fw-bold mb-2">{language[lang].detalhes}</label>
																<textarea name="detalhes"
																	value={dados.current.info.detalhes}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	rows="4"
																	onChange={handle_change_info} />
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].tipo_associado}
																</label>
																<select
																	name="tipo_associado"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={handle_change_info}
																	value={
																		dados?.current?.info?.tipo_associado !== undefined &&
																			dados?.current?.info?.tipo_associado !== null
																			? dados.current.info.tipo_associado
																			: ''
																	}
																>
																	<option value="">{language[lang].select}</option>

																	<option value="2">{language[lang].juvenil}</option>
																	<option value="1">{language[lang].atleta}</option>
																	<option value="0">{language[lang].contribuinte}</option>
																</select>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">
																	{language[lang].valor_quotas}
																</label>
																<input
																	type="text"
																	inputMode="numeric"
																	name="valor_quotas"
																	value={dados.current.info.valor_quotas}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].valor_quotas_placeholder}
																	onChange={(e) => {
																		let value = e.target.value.replace(/[^\d]/g, '');
																		if (value) value += '€';
																		dados.current.info.valor_quotas = value;
																		setForceUpdate((prev) => !prev);
																	}}
																/>
															</div>
														</div>
													)}

													{showContract && (coletivaOrIndividual === true) && (
														<div className="row mb-4">
															<div className="col-md-8">
																<label className="fs-6 fw-bold mb-2">{language[lang].observacao}</label>
																<textarea name="observacao"
																	value={dados.current.info.observacao}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	rows="4"
																	onChange={handle_change_info} />
															</div>
														</div>
													)}

													{showFunctions && (
														<div className="row mb-4 d-none">
															{dados.current.info.entity?.some(option => option.label === 'Externa') && selectedColaborador === '2' ? (
																<>
																	<div className="col-md-3">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																		<select
																			name="user_type"
																			className="form-control mb-4 mb-lg-0 rounded-0"
																			onChange={handleEntidade}
																			value={selectedColaborador || (dados.current.info.entity?.[0]?.id)}
																			required
																		>
																			<option value="Default">{language[lang].select}</option>
																			{entidadeOptions.map((option) => (
																				<option key={option.id} value={option.id}>
																					{option.label}
																				</option>
																			))}
																		</select>
																	</div>
																	<div className="col-md-3">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																		<select
																			name="user_type"
																			className="form-control mb-4 mb-lg-0 rounded-0"
																			onChange={handleTipoEntidade}
																			value={selectedTipoCliente || (dados.current.info.type?.[0]?.id)}
																			required
																		>
																			<option value="Default">{language[lang].select}</option>
																			{tipoEntidadeOptions.map((option) => (
																				<option key={option.id} value={option.id}>
																					{option.label}
																				</option>
																			))}
																		</select>
																	</div>
																	<div className="col-md-6">
																		<label className="fs-6 fw-bold mb-2">{language[lang].relacao}</label>
																		<div className="row ms-3">
																			{tipoRelacaoOptions.map((option) => (
																				<div key={option.id} className="col-md-4 form-check">
																					<input
																						type="checkbox"
																						className="form-check-input"
																						id={`relacao-${option.id}`}
																						value={option.id}
																						onChange={handleRelacaoChange}
																						checked={dados.current.info.relacao?.some(item => item.id === option.id) || false}
																					/>
																					<label className="form-check-label" htmlFor={`relacao-${option.id}`}>
																						{traduzirTipoRelacao(option.label, lang)}
																					</label>
																				</div>
																			))}
																		</div>
																	</div>
																</>
															) : (
																<>
																	<div className="col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																		<select
																			name="user_type"
																			className="form-control mb-4 mb-lg-0 rounded-0"
																			onChange={handleEntidade}
																			value={selectedColaborador || (dados.current.info.entity?.[0]?.id)}
																			required
																		>
																			<option value="Default">{language[lang].select}</option>
																			{entidadeOptions.map((option) => (
																				<option key={option.id} value={option.id}>
																					{traduzEntidade(option.label, lang)}
																				</option>
																			))}
																		</select>
																	</div>
																	<div className="col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																		<select
																			name="user_type"
																			className="form-control mb-4 mb-lg-0 rounded-0"
																			onChange={handleTipoEntidade}
																			value={selectedTipoCliente || (dados.current.info.type?.[0]?.id)}
																			required
																		>
																			<option value="Default">{language[lang].select}</option>
																			{tipoEntidadeOptions.map((option) => (
																				<option key={option.id} value={option.id}>
																					{traduzTipoEntidade(option.label, lang)}
																				</option>
																			))}
																		</select>
																	</div>
																</>
															)}
														</div>
													)}

													{showFunctions && (
														<div className="row mb-4">
															<div className="col-md-3 d-none">
																<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																<select
																	name="entity_category"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	onChange={change_entity_attributes}
																	value={dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== null ? dados.current.info.attributes.entity_category : ''}
																	required
																>
																	<option value="">{language[lang].select}</option>
																	{
																		entity_category.current !== undefined && entity_category.current !== null ?
																			entity_category.current.map((option, key) => (
																				<option key={key} value={option.id}>
																					{option.label}
																				</option>
																			))
																			:
																			null
																	}
																</select>
															</div>

															{
																dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== '' ?
																	<div className="col-md-3">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																		<select
																			name="entity_type"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_entity_attributes}
																			value={dados?.current?.info?.attributes?.entity_type !== undefined && dados?.current?.info?.attributes?.entity_type !== null ? dados.current.info.attributes.entity_type : ''}
																			required
																		>
																			<option value="">{language[lang].select}</option>
																			{
																				entity_type_filter.current !== undefined && entity_type_filter.current !== null ?
																					entity_type_filter.current.map((option, key) => (
																						<option key={key} value={option.id}>
																							{option.label}
																						</option>
																					))
																					:
																					null
																			}
																		</select>
																	</div>
																	:
																	null
															}

															{
																dados?.current?.info?.attributes?.entity_type !== undefined && dados?.current?.info?.attributes?.entity_type !== '' ?
																	<div className="col-md-3">
																		<label className="fs-6 fw-bold mb-2">{language[lang].entity_nature}</label>
																		<select
																			name="entity_nature"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_entity_attributes}
																			value={dados?.current?.info?.attributes?.entity_nature !== undefined && dados?.current?.info?.attributes?.entity_nature !== null ? dados.current.info.attributes.entity_nature : ''}
																			required
																		>
																			<option value="">{language[lang].select}</option>
																			{
																				entity_nature_filter.current !== undefined && entity_nature_filter.current !== null ?
																					entity_nature_filter.current.map((option, key) => (
																						<option key={key} value={option.id}>
																							{option.label}
																						</option>
																					))
																					:
																					null
																			}
																		</select>
																	</div>
																	:
																	null
															}

															<div className="col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].group}</label>
																<div className="form-check form-switch">
																	<input
																		className="form-check-input"
																		type="checkbox"
																		id="groupSwitch"
																		name="group"
																		checked={dados.current.info.group}
																		onChange={(e) => {
																			dados.current.info.group = e.target.checked;
																			setRefresh((prev) => !prev);
																		}}
																	/>
																	<label className="form-check-label" htmlFor="groupSwitch">
																		{dados.current.info.group ? language[lang].ativo : language[lang].inativo}
																	</label>
																</div>
															</div>
														</div>
													)}

													{showFunctions && (
														<div className="row mb-4">
															{
																dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== '' && entity_relation_filter.current !== undefined && entity_relation_filter.current !== null && entity_relation_filter.current.length > 0 ?
																	<div className="col-12">
																		<label className="fs-6 fw-bold mb-2">{language[lang].relacao}</label>
																		<div className="row ms-3">
																			{
																				entity_relation_filter.current !== undefined && entity_relation_filter.current !== null ?
																					entity_relation_filter.current.map((option, key) => (
																						<div key={key} className="col-6 col-md-3 col-lg-2 mb-5 form-check">
																							<input
																								type="checkbox"
																								className="form-check-input"
																								id={`relacao-${option.id}`}
																								value={option.id}
																								onChange={handle_entity_relation}
																								checked={dados.current.info.relacao?.some(item => parseInt(item) === parseInt(option.id)) || false}
																							/>
																							<label className="form-check-label" htmlFor={`relacao-${option.id}`}>
																								{option.label}
																							</label>
																						</div>
																					))
																					:
																					null
																			}
																		</div>
																	</div>
																	:
																	null
															}

														</div>
													)}

													{showFunctions && (
														<div className="row mb-4">
															{(dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') && (
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].profile}</label>
																	<select
																		name="profile"
																		className="form-select form-control mb-3 mb-lg-0 rounded-0"
																		onChange={handleUserTypeChange}
																		value={dados.current.profile.name}
																	>
																		<option value="">{language[lang].choose_profile}</option>
																		{userTypes.map((userType, key) => (
																			<option key={key} value={userType.name}>
																				{traduzPerfil(userType.name, lang)}
																			</option>
																		))}
																	</select>
																</div>
															)}

															{(dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') && (
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																	<select
																		name="entity_profile"
																		className="form-select form-control mb-3 mb-lg-0 rounded-0"
																		onChange={handleUserTypeEntityChange}
																		value={''}
																	>
																		<option value="">{language[lang].choose_profile}</option>
																		{userTypesEntities.map((userTypeEntity, key) => (
																			<option key={key} value={userTypeEntity.name}>
																				{traduzPerfil(userTypeEntity.name, lang)}
																			</option>
																		))}
																	</select>

																	<div>
																		{
																			dados.current.info?.entity_profile !== undefined && Array.isArray(dados.current.info?.entity_profile) ?
																				dados.current.info?.entity_profile.map((el_ep, k_ep) => {
																					return (
																						<span key={k_ep} className='badge bg-secondary mt-2 me-2 px-3 py-2 rounded-0' onClick={() => handleUserTypeEntityRemove(el_ep.id)}>
																							{el_ep.name} <i className="bi bi-x-lg ms-2 text-white"></i>
																						</span>
																					)
																				})
																				:
																				null
																		}
																	</div>
																</div>
															)}
														</div>
													)}

													{showSettings && (
														<div className="row mb-4">
															{/* Left Column: Cliente & Estado */}
															<div className="col-md-6">
																<div className="mb-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].cliente}</label>
																	<div className="d-flex flex-column gap-2">
																		{console.log('entity_list.current entity_list.current entity_list.current', entity_list.current)}
																		{entity_list.current
																			.map((item) => (
																				<div className="form-check" key={item.id}>
																					<input
																						className="form-check-input"
																						type="checkbox"
																						id={`cliente_${item.id}`}
																						value={item.id}
																						checked={Array.isArray(dados.current.info.cliente) && dados.current.info.cliente.includes(item.id)}
																						onChange={(e) => {
																							const checked = e.target.checked;
																							const value = e.target.value;
																							if (!Array.isArray(dados.current.info.cliente)) {
																								dados.current.info.cliente = [];
																							}

																							if (checked) {
																								if (!dados.current.info.cliente.includes(value)) {
																									dados.current.info.cliente.push(value);
																								}
																							} else {
																								dados.current.info.cliente = dados.current.info.cliente.filter(v => v !== value);
																							}

																							change_entity_attributes(e);
																						}}
																					/>
																					<label className="form-check-label" htmlFor={`cliente_${item.id}`}>
																						{item.info.name}
																					</label>
																				</div>
																			))}
																	</div>
																</div>

																<div className="mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].estado}</label>
																	<div className="form-check form-switch">
																		<input
																			className="form-check-input"
																			type="checkbox"
																			id="estadoSwitch"
																			name="estado"
																			checked={dados.current.info.estado}
																			onChange={(e) => {
																				dados.current.info.estado = e.target.checked;
																				setRefresh((prev) => !prev);
																			}}
																		/>
																		<label className="form-check-label" htmlFor="estadoSwitch">
																			{dados.current.info.estado ? language[lang].ativo : language[lang].inativo}
																		</label>
																	</div>
																</div>
															</div>

															{/* Right Column: Foto Upload */}
															<div className="col-md-6 p-4 bg-white shadow-sm rounded">
																<div className="mt-4">
																	<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
																		{
																			logo_base64 !== '' ?
																				<img
																					src={logo_base64}
																					className="img-fluid rounded"
																					alt="Uploaded"
																					style={{ width: "120px", height: "120px", objectFit: "cover" }}
																				/>
																				:
																				dados?.current?.info?.foto?.length > 0 ? (
																					dados.current.info.foto.map((file, index) => {
																						const imageURL = file.link || URL.createObjectURL(file);
																						return (
																							<li key={index} className="d-flex flex-column align-items-center">
																								<img
																									src={imageURL}
																									className="img-fluid rounded"
																									alt="Uploaded"
																									style={{ width: "120px", height: "120px", objectFit: "cover" }}
																								/>
																								<small className="mt-2 text-muted">{file.name || 'Imagem'}</small>
																							</li>
																						);
																					})
																				) : (
																					<li className="text-muted">
																						{coletivaOrIndividual === true
																							? language[lang].noLogo
																							: language[lang].noPhoto}
																					</li>
																				)}
																	</ul>

																	<div className="d-flex justify-content-center mt-4 gap-2">
																		<input
																			type="file"
																			// accept="image/*"
																			accept=".jpeg,.jpg,.png"
																			onChange={onChangeHandlerFilesImage}
																			data-order={1}
																			data-langid={lang_id}
																			data-lang={lang}
																			data-type={'image'}
																			className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																			id="photo-upload"
																		/>

																		<label htmlFor="photo-upload" className="btn btn-outline-primary btn-sm">
																			{coletivaOrIndividual === true
																				? language[lang].logo
																				: language[lang].photo}
																		</label>

																		{dados?.current?.info?.foto?.length > 0 && (
																			<button
																				type="button"
																				onClick={handleFileRemove}
																				style={{
																					marginLeft: "5px",
																					backgroundColor: color.corVermelha.rgb,
																					color: "#FFF",
																					border: "none",
																					borderRadius: "5px",
																					cursor: "pointer",
																					padding: "3px 10px",
																				}}
																			>
																				X
																			</button>
																		)}
																	</div>
																</div>
															</div>
														</div>
													)}


													{showFiscalData && (coletivaOrIndividual === true) && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].cae}</label>
																<input type="text"
																	inputMode='numeric'
																	name="cae"
																	value={dados.current.info.cae}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].cae_placeholder}
																	onChange={handle_change_info} />
															</div>
														</div>
													)}

													{showFiscalData && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">
																	{language[lang].vat}
																</label>
																<input type="text"
																	pattern={pattern_vat}
																	minLength="9"
																	inputMode='numeric'
																	name="vat"
																	value={dados.current.info.vat}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].vat_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>

													)}

													{showFiscalData && (coletivaOrIndividual === false) && (
														<div className="row mb-4">
															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">
																	{language[lang].nbss}
																</label>
																<input type="text"
																	pattern={pattern_vat}
																	minLength="9"
																	inputMode='numeric'
																	name="nbss"
																	value={dados.current.info.nbss}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].nbss_placeholder}
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-5 fw-bold mb-2">
																	{language[lang].ass}
																</label>
																<input type="text"
																	pattern={pattern_vat}
																	minLength="9"
																	inputMode='numeric'
																	name="ass"
																	value={dados.current.info.ass}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].ass_placeholder}
																	onChange={handle_change_info}
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-5 fw-bold mb-2">
																	{language[lang].iban}
																</label>
																<input type="text"
																	minLength="25"
																	inputMode='numeric'
																	name="iban"
																	value={dados.current.info.iban}
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].iban_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}
												</div>
											</div>
										</form>
									</div>
								</div>

								<div className="card mt-5">
									{(dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') && (
										<>
											<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
												</div>
											</div>

											<div id="div_entidade_password" className="collapse show">
												<form id="form_user" onSubmit={handleSubmitPassword}>
													<div className="card-body border-top p-4">
														<div className="row mb-6">
															<div className="col-md-4 fv-row">
																<label className="fs-5 fw-bold mb-2">{language[lang].username}</label>
																<input
																	type="text"
																	name="username"
																	value={dados.current.info.username}
																	pattern="[a-zA-Z\u00C0-\u00FF.]+"
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].username_placeholder}
																	onChange={handle_change_info}
																	onBlur={handle_change_login}
																	autoComplete="off"
																/>
															</div>

															<div className="col-md-4 fv-row">
																<label className="fs-5 fw-bold mb-2">{language[lang].password}</label>
																<input
																	type="password"
																	name="password"
																	value={new_password}
																	min="9"
																	title="A password deve de conter pelo menos 9 digitos alfa-númericos"
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].password_placeholder}
																	onChange={handle_change_info_new_password}
																	autoComplete="off"
																/>
															</div>
															<div className="col-md-4 fv-row">
																<label className="fs-5 fw-bold mb-2">{language[lang].password_confirmation}</label>
																<input
																	type="password"
																	name="password_conf"
																	defaultValue={confirm_password}
																	min="9"
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].password_placeholder}
																	onBlur={handle_change_password}
																	autoComplete="off"
																/>
															</div>
														</div>
													</div>
												</form>
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
